import React, { useState, useContext, useEffect } from "react";
import { useQuery } from "react-query";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import CircularProgress from "@mui/material/CircularProgress";
import AlertIconDisplay from "./AlertIconGroup";
import { getAlertLogsDataFromvehicleKey } from "../../services/vehicle";
import { detailsTabsBoxStyle } from "../../services/Utils";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import { formatDate } from "../../services/Utils";
import DraftsIcon from "@mui/icons-material/Drafts";
import ListItemIcon from "@mui/material/ListItemIcon";
import { DateAndTimeGridCell } from "../common/DateAndTimeGridCell";

function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell style={{ width: "67px" }}>
          <IconButton
            aria-label="expand row"
            size="small"
            disabled={row?.count === 1}
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell>
          <AlertIconDisplay alertType={row} />
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={2}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <List sx={{ bgcolor: "background.paper", paddingLeft: "3em" }}>
                {row?.messages.map((msg, index) => (
                  <React.Fragment>
                    <ListItem alignItems="flex-end">
                      <ListItemIcon>
                        <DraftsIcon />
                      </ListItemIcon>
                      <ListItemText
                        primary={
                          <DateAndTimeGridCell
                            value={msg.createdAt}
                            singleLine={true}
                          />
                        }
                        secondary={
                          <React.Fragment>
                            <Typography
                              sx={{ display: "inline" }}
                              component="span"
                              variant="body2"
                              color="text.primary"
                            ></Typography>
                            {msg.message}
                          </React.Fragment>
                        }
                      />
                    </ListItem>
                    {index < row?.messages.length - 1 && (
                      <Divider variant="inset" component="li" />
                    )}
                  </React.Fragment>
                ))}
              </List>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

const AlertLogList = ({ vehicleData }) => {
  const { device } = vehicleData;
  let { data, isLoading, error, isError } = useQuery(
    ["fetchAlertLogList", device?.vehicleKey],
    getAlertLogsDataFromvehicleKey,
    {
      enabled: !!device?.vehicleKey,
      refetchOnWindowFocus: false,
    }
  );
  const loadAlertData = data?.length ? data : [];

  return (
    <TableContainer component={Paper} {...detailsTabsBoxStyle}>
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow>
            <TableCell />
            <TableCell>Alert Category</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <TableRow>
              <TableCell colSpan={2} align="center" sx={{ py: 4 }}>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", margin: "10%" }}><CircularProgress /></div>
                <Typography variant="body2" sx={{ mt: 2 }}>
                  Loading data...
                </Typography>
              </TableCell>
            </TableRow>
          ) : isError ? (
            <TableRow>
              <TableCell colSpan={2} align="center" sx={{ py: 4 }}>
                <Typography color="error">
                  Error loading data: {error.message}
                </Typography>
              </TableCell>
            </TableRow>
          ) : loadAlertData.length === 0 ? (
            <TableRow>
              <TableCell colSpan={2} align="center" sx={{ py: 4 }}>
                <Typography variant="body2" color="textSecondary">
                  No data available
                </Typography>
              </TableCell>
            </TableRow>
          ) : (
            loadAlertData.map((row) => <Row key={row.alertLogId} row={row} />)
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default AlertLogList;
